import * as Sentry from '@sentry/react';

import { notify } from '@/components/toast';

export const executeStringFn = <T = unknown, R = T>(
  data: T,
  fn: string
): R | undefined => {
  try {
    const func = new Function('data', `return (${fn})(data)`);
    return func(data);
  } catch (error) {
    console.error('Error executing function:', error);
    Sentry.captureException(error, {
      level: 'error',
      extra: {
        section: 'executeStringFn',
        functionString: fn,
        inputData: JSON.stringify(data, null, 2)
      }
    });
    notify.error('Error executing function. Check console for details.');
    return;
  }
};
